module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/credit_card-5af2fddf.svg";